import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Image from "gatsby-image";
import { rhythm } from "../../utils/typography";
import "./index.css";

const Header = (location) => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      avatar: file(absolutePath: { regex: "/profile-pic.jpg/" }) {
        childImageSharp {
          fixed(width: 96, height: 96) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `);

  const path = location.location.pathname;

  return (
    <div className="header-main">
      <Link to={`/`} style={{ boxShadow: `none` }}>
        <Image
          className="logo"
          fixed={data.avatar.childImageSharp.fixed}
          alt={`Logo`}
          style={{
            marginRight: rhythm(1 / 2),
            marginBottom: 0,
            minWidth: 96,
            minHeight: 96,
            borderRadius: `100%`,
          }}
          imgStyle={{
            borderRadius: `50%`,
          }}
        />
      </Link>
      <ul className="header-links">
        <li>
          <Link
            to={`/`}
            className={
              path === "/" ? `header-link-active` : `header-link-inactive`
            }
          >
            Books
          </Link>
        </li>
        <li>
          <Link
            to={`/cinema`}
            className={
              path === "/cinema" ? `header-link-active` : `header-link-inactive`
            }
          >
            Cinema
          </Link>
        </li>
        <li>
          <Link
            to={`/poetry`}
            className={
              path === "/poetry" ? `header-link-active` : `header-link-inactive`
            }
          >
            Poetry
          </Link>
        </li>
        <li>
          <Link
            to={`/people`}
            className={
              path === "/people" ? `header-link-active` : `header-link-inactive`
            }
          >
            People
          </Link>
        </li>
        <li>
          <Link
            to={`/newsletter`}
            className={
              path === "/newsletter"
                ? `header-link-active header-newsletter`
                : `header-link-inactive header-newsletter`
            }
          >
            Newsletter
          </Link>
        </li>
      </ul>
      <div style={{ clear: `both` }}></div>
    </div>
  );
};

export default Header;
